import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { StyledRating, StyledRatingContainer, StyledReviews, StyledLink } from './styles';

const DS_FooterReview = ({ logo, stars, info }) => {
  const { url, score, maxScore, title, urlLabel } = info;

  return (
    <StyledReviews data-test="footer-ekomi">
      {logo?.gatsbyImageData && <GatsbyImage image={logo.gatsbyImageData} alt={logo.title || 'review logo'} />}
      <StyledRatingContainer>
        <span>{title}</span>
        <StyledRating>
          {stars?.gatsbyImageData && <GatsbyImage image={stars.gatsbyImageData} alt={stars.title || 'stars'} />}
          <span>
            {score} / {maxScore}
          </span>
        </StyledRating>
        {url && (
          <StyledLink url={url} target="_blank">
            {urlLabel}
          </StyledLink>
        )}
      </StyledRatingContainer>
    </StyledReviews>
  );
};

export default DS_FooterReview;
